import React, { useId, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

// Labeled input used by Auth V2 views. For type="password" it renders a
// keyboard-accessible visibility toggle; the underlying input keeps
// type="password" by default (masked) so existing password-field selectors
// in tests are unaffected.
export default function AuthField({
  id, label, type = 'text', value, onChange, autoComplete, placeholder,
  autoFocus = false, inputMode, error, required = false,
}) {
  const autoId = useId();
  const fieldId = id || autoId;
  const errorId = `${fieldId}-error`;
  const [visible, setVisible] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword ? (visible ? 'text' : 'password') : type;

  return (
    <div className="auth-field">
      <label htmlFor={fieldId} className="auth-field-label">{label}</label>
      <div className="auth-field-control">
        <input
          id={fieldId}
          type={inputType}
          className={isPassword ? 'auth-field-input-toggleable' : undefined}
          value={value}
          onChange={onChange}
          autoComplete={autoComplete}
          placeholder={placeholder}
          autoFocus={autoFocus}
          inputMode={inputMode}
          required={required}
          aria-invalid={error ? 'true' : undefined}
          aria-describedby={error ? errorId : undefined}
        />
        {isPassword && (
          <button
            type="button"
            className="auth-field-toggle"
            aria-label={visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
            onClick={() => setVisible((v) => !v)}
          >
            {visible ? <EyeOff size={18} aria-hidden="true" /> : <Eye size={18} aria-hidden="true" />}
          </button>
        )}
      </div>
      {error && <p id={errorId} className="auth-field-error">{error}</p>}
    </div>
  );
}
